<template>
  <main class="page-main">
    <div class="uk-grid" data-uk-grid>
      <!-- 左侧主要内容 -->
      <div class="uk-width-2-3@l">
        <div class="widjet --steps">
          <div class="widjet__head">
            <h3 class="uk-text-lead">使用指南</h3>
          </div>
          <div class="widjet__body">
            <div class="guide-section">
              <!-- 1. 下载客户端 -->
              <div class="section">
                <h1 class="section-title">1. 下载客户端</h1>
                <p class="step">
                  <a href="https://study.s3.bitiful.net/newtop%2F%E9%80%9F%E8%81%94-1.0.0.exe" class="download-btn">【最新版点击下载】</a>
                </p>
                <p class="step">
                  <a href="https://study.s3.bitiful.net/newtop%2Forigin-sulian-top.exe" class="download-btn">【兼容版备用下载】</a>
                </p>
                <img src="@/assets/img/w1.jpg" alt="注册流程1" class="guide-img" />
                <img src="@/assets/img/w2.jpg" alt="注册流程2" class="guide-img" />
                <img src="@/assets/img/w3.jpg" alt="注册流程3" class="guide-img" />
              </div>

              <!-- 2. 注册登录 -->
              <div class="section">
                <h1 class="section-title">2. 注册登录</h1>
                <p class="info-text">（账号独立使用，稳定、安全）</p>
                <img src="@/assets/img/w4.jpg" alt="注册流程4" class="guide-img" />
                <img src="@/assets/img/w5.jpg" alt="注册流程5" class="guide-img" />
              </div>

              <!-- 3. 兑换优惠券码 -->
              <div class="section">
                <h1 class="section-title">3. 兑换优惠券码</h1>
                <img src="@/assets/img/w6.jpg" alt="兑换优惠券码" class="guide-img" />
              </div>

              <!-- 4. 连接网络 -->
              <div class="section">
                <h1 class="section-title">4. 连接网络</h1>
                <img src="@/assets/img/w7.jpg" alt="网络连接" class="guide-img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧附加信息 -->
      <div class="uk-width-1-3@l">
        <div class="widjet --support">
          <div class="widjet__head">
            <h3 class="uk-text-lead">测试 & 常见问题</h3>
          </div>
          <div class="widjet__body">
            <p class="support-text">
              <strong>点</strong>
              <a href="http://google.com/" target="_blank" class="test-link">google.com</a>
              打开网址测试，能使用说明线路连接成功，开始快乐看世界~
            </p>
            <img src="@/assets/img/20241030214338Htdi.png" alt="测试示例" class="guide-img" />

            <h3 class="faq-title">节点全是红色？</h3>
            <p>把 **电脑时间改成和手机(北京)时间一致**</p>
            <p>注意：设备时间误差 **不得超过1分钟**</p>

            <h3 class="faq-title">其他问题</h3>
            <p>如果仍有问题，请联系客服。</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "UserGuide",
};
</script>

<style scoped>
/* 🌟 页面整体布局 */
.page-main {
  width: 100%;
  padding: 20px;
  background: #f9f9f9;
}

/* 🌟 主要内容区 */
.widjet {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.widjet__head h3 {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 标题样式 */
.section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #ddd;
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 🌟 下载按钮 */
.download-btn {
  display: inline-block;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background-color: rgb(192, 0, 0);
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s;
}

.download-btn:hover {
  background-color: rgb(150, 0, 0);
}

/* 🌟 图片样式 */
.guide-img {
  width: 100%;
  max-width: 900px;
  height: auto;
  margin: 15px 0;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* 🌟 常见问题 */
.faq-title {
  font-size: 18px;
  font-weight: bold;
  color: rgb(54, 113, 185);
  margin-top: 20px;
}

.test-link {
  color: rgb(255, 111, 4);
  text-decoration: none;
  font-weight: bold;
}

.test-link:hover {
  text-decoration: underline;
}
</style>
